import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { ReduxUtils } from '@spm/core';
import { combineReducers } from 'redux';
import * as ACTIONTYPES from './actionTypes';

/**
 * Put the page details of the form in the store.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
export var pageDetailsReducer = function pageDetailsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  // Check if it is an update or a request action.
  if (action.type === ACTIONTYPES.FORM_UPDATE_PAGE_DETAILS_TYPES) {
    return _Object$assign({}, state, {
      payload: action.payload
    });
  }
  return ReduxUtils.generateReducer(state, action, ACTIONTYPES.GET_FORM_PAGE_DETAILS_TYPES);
};

/**
 * Get Page Details Error reducer
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
export function pageDetailsErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, ACTIONTYPES.GET_FORM_PAGE_DETAILS_TYPES);
}

/**
 * Delete Summary Page Record Reducer.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
export function deleteSummaryPageRecordErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, ACTIONTYPES.FORM_DELETE_SUMMARY_PAGE_RECORD);
}

/**
 * Save Page Answers Error reducer
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
export function sendPageAnswersErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, ACTIONTYPES.FORM_SEND_PAGE_ANSWERS_TYPES);
}

/**
 * Put the IEG hook binding key in the store.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
export var iegHookBindingKeyReducer = function iegHookBindingKeyReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: ACTIONTYPES.SET_IEG_HOOK_BINDING_KEY_TYPES
  });
};

/**
 * Put the form id in the store.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
export var formIdReducer = function formIdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: ACTIONTYPES.SET_FORM_ID_TYPES
  });
};

/**
 * Put the form id in the store.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
export var formDetailsReducer = function formDetailsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: ACTIONTYPES.FORM_DETAILS_TYPES
  });
};

/**
 * Updates if the submit is enabled or not for an IEG Form in the store.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
export var submitEnabledReducer = function submitEnabledReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: ACTIONTYPES.FORM_SUBMIT_ENABLED_TYPES
  });
};

/**
 * Accesses a specific piece of data to indicate if 'goToPage' is being posted.
 *
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 * @returns a boolean to indicate if 'goToPage' is being posted.
 */
export function isPostingGoToPageReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, ACTIONTYPES.FORM_GO_TO_PAGE);
}

/**
 * Accesses 'goToPage' error data from the store.
 *
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 * @returns Any error messages encountered when moving the script to the first page.
 */
export function goToPageErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, ACTIONTYPES.FORM_GO_TO_PAGE);
}
var reducers = combineReducers({
  pageDetails: pageDetailsReducer,
  iegHookBindingKey: iegHookBindingKeyReducer,
  formId: formIdReducer,
  sendPageAnswersError: sendPageAnswersErrorReducer,
  pageDetailsError: pageDetailsErrorReducer,
  deleteSummaryPageRecordError: deleteSummaryPageRecordErrorReducer,
  formDetails: formDetailsReducer,
  submitEnabled: submitEnabledReducer,
  isPostingGoToPage: isPostingGoToPageReducer,
  goToPageError: goToPageErrorReducer
});
export default {
  reducers: reducers
};